"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectedTreeNodeForTaskView = void 0;
const product_tree_node_1 = require("../../../client/product-tree-node");
const task_view_1 = require("../../../store/catalogs/task-view");
const useSelectedTreeNodeForTaskView = () => {
    const selectedStrategyNodeId = (0, task_view_1.useTaskViewProductsTableSelectedTreeNodeId)();
    const response = (0, product_tree_node_1.useProductTreeNode)({ id: selectedStrategyNodeId });
    return response === null || response === void 0 ? void 0 : response.data;
};
exports.useSelectedTreeNodeForTaskView = useSelectedTreeNodeForTaskView;
